import { isPPLClient } from '@root/helpers/env/is-ppl-client';
import { cva } from 'class-variance-authority';

export const blockTitleClasses = cva(
  ['leading-normal', 'font-semibold', 'text-xs', 'break-words', 'uppercase', 'text-info-600'],
  {
    variants: {
      type: {
        clause: ['w-full'],
        'clause-heading': ['w-mrc-block-title', 'mr-mrc-block-grid-cell', isPPLClient() ? 'min-w-mrc-block-title' : ''],
        generic: ['w-full'],
        attachment: ['w-full'],
        'mrc-heading': ['w-mrc-block-title', 'mr-mrc-block-grid-cell', isPPLClient() ? 'min-w-mrc-block-title' : ''],
      },
      pdf: {
        false: [],
        clause: [],
        'clause-heading': [],
        generic: [],
        attachment: [],
        'mrc-heading': [],
      },
    },
  },
);

export const blockContentClasses = cva(
  ['relative', 'block-content', 'w-full', 'flex-auto', 'min-w-0', 'overflow-x-hidden'],
  {
    variants: {
      type: {
        attachment: ['attachment-block'],
        clause: ['clause-block'],
        'clause-heading': ['clause-heading-block'],
        generic: ['generic-block'],
        'mrc-heading': ['mrc-heading-block'],
      },
      pdf: {
        false: [],
        clause: [],
        'clause-heading': [],
        generic: [],
        attachment: [],
        'mrc-heading': [],
      },
      disableMentions: {
        true: ['remove-interactive-mention'],
        false: [],
      },
    },
    defaultVariants: {
      disableMentions: false,
      pdf: false,
      type: 'mrc-heading',
    },
  },
);
